//Modules
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MbscModule } from '@mobiscroll/angular';
import { SwiperModule  } from 'swiper/angular';
import { ShotFooterModule } from '../shot-footer/shot-footer.module';
import { CommonSharedModule } from '../common-shared/common-shared.module';
import { NgOptimizedImage } from '@angular/common';

//utility
import { SlotsPipe,KeysPipe, KeysDisplayPipe,ObjectPipe ,GetValuesPipe, CurrencyPipe } from './utility/slots.pipe';
import { Utility } from './utility/utility';
import { CustomValidators } from './utility/custom-validator';

//directives
import { HomebannerDirective } from '../homebanner.directive';
import { BlockCopyPasteDirective } from '../directives/copypaste.directive';
// import { DisableControlDirective } from '../directives/disable-control.directive';
import { TwoDigitDecimaNumberDirective } from '../twodigitdecimalnumber.directive';

//pipes
import { SafeHtmlPipe } from '../safe-html.pipe';
import { GamesTagFilterPipe, GameTagFilterPipe } from './utility/games-tag-filter.pipe';
import { countryName } from '../app-footer/lang.pipe';

//services
import { StaticPageService } from '../services/static-page.service';
import { ModalService } from './services/modal.service';

//Components
import { ModalComponent } from './modal/modal.component';
import { CountryBlockedComponent } from '../app-myaccount/country-blocked/country-blocked.component';
import { PreferenceCenterComponent } from '../app-myaccount/complete-profile/preference-center/preference-center.component';
import { AccountPreferenceComponent } from '../account-preference/account-preference.component';
import { MyaccountHeaderComponent } from '../myaccount-header/myaccount-header.component';
import { LandingPageComponent } from '../landing-page/landing-page.component';
import { AbortRegistrationComponent } from './abort-registration/abort-registration.component';
import { AppHomebannerComponent } from '../app-homebanner/app-homebanner.component';
import { CryptoCashierComponent } from '../crypto-cashier/crypto-cashier.component';
import { SeoContentComponent } from '../seo-content/seo-content.component';
import { CarouselBannerComponent } from '../carousel-banner/carousel-banner.component';
import { CustomSelectorComponent } from './custom-feilds/custom-selector/custom-selector.component';
import { CustomInputComponent } from './custom-feilds/custom-input/custom-input.component';
import { CustomErrorMessageComponent } from './custom-feilds/custom-error-message/custom-error-message.component';
import { AppHomeGamesLangComponent } from '../app-home-games-lang/app-home-games-lang.component';
import { SlotGamesSearchComponent } from '../lobby/slot-games-search/slot-games-search.component';
import { SlotGameModalComponent } from '../lobby/slot-game-modal/slot-game-modal.component';
import { LobbyGameResultPageComponent } from '../lobby/lobby-game-result-page/lobby-game-result-page.component';
import { LobbyGameByThemeComponent } from '../lobby/lobby-game-by-theme/lobby-game-by-theme.component';
import { LobbyFilterGroupComponent } from '../lobby/lobby-filter-group/lobby-filter-group.component';
import { LobbySortingComponent } from '../lobby/lobby-filter-group/lobby-sorting/lobby-sorting.component';
import { LobbyFiltersComponent } from '../lobby/lobby-filter-group/lobby-filters/lobby-filters.component';
import { LobbyTabsComponent } from '../lobby/lobby-filter-group/lobby-tabs/lobby-tabs.component';
import { LiveCasinoDetailsComponent } from '../lobby/lobby-game-card/live-casino-details/live-casino-details.component';
import { LobbyGameCardComponent } from '../lobby/lobby-game-card/lobby-game-card.component';
import { LobbyGameGroupComponent } from '../lobby/lobby-game-group/lobby-game-group.component';
import { SearchStickyBarComponent } from '../search-sticky-bar/search-sticky-bar.component';
import { GameProvidersComponent } from '../lobby/game-providers/game-providers.component';
import { BonusesComponent } from '../app-myaccount/bonuses/bonuses.component';
import { CompleteProfileComponent } from '../app-myaccount/complete-profile/complete-profile.component';
import { TransactionComponent } from '../app-myaccount/transaction/transaction.component';
import { BetHistoryComponent } from '../app-myaccount/bet-history/bet-history.component';
import { ChangePasswordComponent } from '../app-myaccount/complete-profile/change-password/change-password.component';
import { UpdateProfileComponent } from '../app-myaccount/complete-profile/update-profile/update-profile.component';
import { RegistrationStepOneComponent } from '../app-registration/registration-step-one/registration-step-one.component';
import { RegistrationStepTwoComponent } from '../app-registration/registration-step-two/registration-step-two.component';
import { PagenotfoundComponent } from '../app-myaccount/pagenotfound/pagenotfound.component';
import { StaticPagesComponent } from '../static-pages/static-pages.component';
import { BlockedUserComponent } from '../blocked-user/blocked-user.component';
import { LobbySwiperComponent } from '../lobby/lobby-swiper/lobby-swiper.component';
import { CashierBannerComponent } from '../cashier/components/cashier-banner/cashier-banner.component';
import { ZimplerQuickdepositComponent } from '../zimpler-quickdeposit/zimpler-quickdeposit.component';
import { EnvironmentService } from './services/environment.services';
import { LazyLoadImageDirective } from '../lazy-load-image.directive';
import { CoolOffComponent } from '../cool-off/cool-off.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NgOptimizedImage,
        RouterModule,
        ShotFooterModule,
        CommonSharedModule,
        MbscModule,
        SwiperModule
        ],
    declarations: [
        ModalComponent,
        SlotsPipe,
        GamesTagFilterPipe,
        GameTagFilterPipe,
        KeysPipe,
        KeysDisplayPipe,
        ObjectPipe,
        BlockCopyPasteDirective,
        TwoDigitDecimaNumberDirective,
        SafeHtmlPipe,
        GetValuesPipe,
        CurrencyPipe,
        CountryBlockedComponent,
        PreferenceCenterComponent,
        AccountPreferenceComponent,
        MyaccountHeaderComponent,
        LandingPageComponent,
        AbortRegistrationComponent,
        AppHomebannerComponent,
        HomebannerDirective,
        BonusesComponent,
        CompleteProfileComponent,
        CoolOffComponent,
        TransactionComponent,
        BetHistoryComponent,
        ChangePasswordComponent,
        UpdateProfileComponent,
        LobbyGameGroupComponent,
        LobbyGameCardComponent,
        LiveCasinoDetailsComponent,
        LobbyTabsComponent,
        LobbyFiltersComponent,
        LobbySortingComponent,
        LobbyFilterGroupComponent,
        LobbyGameByThemeComponent,
        LobbyGameResultPageComponent,
        AppHomeGamesLangComponent,
        SlotGameModalComponent,
        SlotGamesSearchComponent,
        countryName,
        SearchStickyBarComponent,
        SeoContentComponent,
        GameProvidersComponent,
        CryptoCashierComponent,
        CarouselBannerComponent,
        CustomSelectorComponent,
        CustomInputComponent,
        CustomErrorMessageComponent,
        RegistrationStepOneComponent,
        RegistrationStepTwoComponent,
        StaticPagesComponent,
    PagenotfoundComponent,
    BlockedUserComponent,
    LobbySwiperComponent,
    CashierBannerComponent,
    ZimplerQuickdepositComponent,
    LazyLoadImageDirective
    ],
    providers: [
        StaticPageService,
        ModalService,
        CustomValidators,
        Utility,
        SlotsPipe,
        GamesTagFilterPipe,
        GameTagFilterPipe,
        KeysPipe,
        KeysDisplayPipe,
        ObjectPipe,
        countryName,
        GetValuesPipe,
        CurrencyPipe,
        BlockCopyPasteDirective,
        TwoDigitDecimaNumberDirective,
        EnvironmentService
    ],
    exports: [
        ModalComponent,
        FormsModule,
        ReactiveFormsModule,
        SlotsPipe,
        GamesTagFilterPipe,
        GameTagFilterPipe,
        KeysPipe,
        KeysDisplayPipe,
        ObjectPipe,
        GetValuesPipe,
        CurrencyPipe,
        BlockCopyPasteDirective,
        TwoDigitDecimaNumberDirective,
        SafeHtmlPipe,
        CountryBlockedComponent,
        PreferenceCenterComponent,
        AccountPreferenceComponent,
        MyaccountHeaderComponent,
        LandingPageComponent,
        AbortRegistrationComponent,
        AppHomebannerComponent,
        BonusesComponent,
        CompleteProfileComponent,
        CoolOffComponent,
        TransactionComponent,
        BetHistoryComponent,
        ChangePasswordComponent,
        UpdateProfileComponent,
        LobbyGameGroupComponent,
        LobbyGameCardComponent,
        LiveCasinoDetailsComponent,
        LobbyTabsComponent,
        LobbyFiltersComponent,
        LobbySortingComponent,
        LobbyFilterGroupComponent,
        LobbyGameByThemeComponent,
        LobbyGameResultPageComponent,
        AppHomeGamesLangComponent,
        SlotGameModalComponent,
        SlotGamesSearchComponent,
        countryName,
        SearchStickyBarComponent,
        SeoContentComponent,
        CryptoCashierComponent,
        CarouselBannerComponent,
        CustomInputComponent,
        CustomSelectorComponent,
        CustomErrorMessageComponent,
        NgOptimizedImage,
        ShotFooterModule,
        CommonSharedModule,
        RegistrationStepOneComponent,
        RegistrationStepTwoComponent,
        StaticPagesComponent,
    PagenotfoundComponent,
    BlockedUserComponent,
    MbscModule,
    SwiperModule,
    LobbySwiperComponent,
    CashierBannerComponent,
    ZimplerQuickdepositComponent
    ],
    schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {

}